export default __webpack_public_path__ + "static/media/package2.8de6e2bd.png";